import Button from "components/common/button/Button";
import Calendar from "components/common/calendar/Calendar";
import DateInput from "components/common/form/inputs/date/DateInput";
import PageHeader from "components/common/page/PageHeader";
import Tab from "components/common/tabs/Tab";
import Tabs from "components/common/tabs/Tabs";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import DemoForm from "./tabs/DemoFrom";
import DemoNotification from "./tabs/DemoNotification";

const DemoPage = () => {

    const [dateModel, setDateModel] = useState<Date | undefined>(new Date());
    const location = useLocation();

    return (
        <div>
            <PageHeader title="demo" />
            <Tabs>
                <Tab title="form" reloadOnFocus name="form">
                    <DemoForm />
                </Tab>
                <Tab title="calendar" reloadOnFocus name="calendar">
                    <Calendar name="demo-page-calendar" />
                    <DateInput
                        value={dateModel}
                        onChange={d => setDateModel(d)}
                    />
                </Tab>
                <Tab title="modal" reloadOnFocus name="modal">
                    <Link to="#modal">
                        pend modal
                    </Link>
                </Tab>
                <Tab title="buttons" name="buttons">
                    <div>
                        <Button theme="default" title="default" >
                            <>default</>
                        </Button>
                        <Button theme="default primary" title="default primary" >
                            <>default primary</>
                        </Button>
                        <Button theme="link" title="link" >
                            <>link</>
                        </Button>
                        <Button theme="link primary" title="link primary" >
                            <>link primary</>
                        </Button>
                    </div>
                </Tab>
                <Tab title="notifications" name="notifications">
                    <DemoNotification />
                </Tab>
            </Tabs>
        </div>
    );
}
export default DemoPage;
